import { render } from "./ShoppingListPage.vue?vue&type=template&id=0b14a552&scoped=true"
import script from "./ShoppingListPage.vue?vue&type=script&lang=js"
export * from "./ShoppingListPage.vue?vue&type=script&lang=js"

import "./ShoppingListPage.vue?vue&type=style&index=0&id=0b14a552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b14a552"]])

export default __exports__